<script>
  import { onMount } from "svelte";
  import {
    Page,
    Card,
    CardHeader,
    CardContent,
    Block,
    List,
    ListItem,
    Button,
  } from "framework7-svelte";
  import { BASE_URL } from "../services/service.config";
  import TradingNavbar from "../components/TradingNavbar.svelte";

  let holidays = [];
  let timings = [];
  let isLoading = false;
  let errorMessage = null;

  async function loadCalendarData() {
    isLoading = true;
    errorMessage = null;
    try {
      // 1. Load Holidays
      const holRes = await fetch(`${BASE_URL}/api/v1/calendar/holidays`);
      if (!holRes.ok) {
        throw new Error(`Failed to load holidays (HTTP ${holRes.status})`);
      }
      const holJson = await holRes.json();
      const holList = Array.isArray(holJson.data) ? holJson.data : (Array.isArray(holJson) ? holJson : []);
      holidays = holList.map(h => ({
        name: h.holiday_name || h.name || "-",
        date: h.holiday_date || h.date || "-",
        desc: h.description || h.desc || "-",
      }));

      // 2. Load Timings
      const timRes = await fetch(`${BASE_URL}/api/v1/calendar/timings`);
      if (timRes.ok) {
        const timJson = await timRes.json();
        const d = timJson.data || timJson;
        if (Array.isArray(d)) {
          timings = d.map(t => ({
            session: t.session || t.name || "-",
            time: t.time || `${t.start_time || ''} - ${t.end_time || ''} IST`,
            purpose: t.purpose || t.description || "-",
          }));
        } else if (d && typeof d === "object") {
          timings = [
            {
              session: "Pre-Open Session",
              time: `${d.pre_open_start || "09:00:00"} - ${d.pre_open_end || "09:08:00"} IST`,
              purpose: "Order entry, price discovery & modification",
            },
            {
              session: "Continuous Normal Trading",
              time: `${d.normal_market_open || "09:15:00"} - ${d.normal_market_close || "15:30:00"} IST`,
              purpose: "Live market order matching & autonomous strategy fanout",
            },
            {
              session: "Post-Close Session",
              time: `${d.normal_market_close || "15:30:00"} - ${d.post_close_end || "16:00:00"} IST`,
              purpose: "Closing price determination & trade reconciliation",
            },
          ];
        }
      }
    } catch (err) {
      console.error("Error loading market calendar data:", err);
      holidays = [];
      timings = [];
      errorMessage = err.message || "Failed to load market calendar";
    } finally {
      isLoading = false;
    }
  }

  onMount(() => {
    loadCalendarData();
  });
</script>

<Page name="market-calendar">
  <TradingNavbar title="Market Calendar & Exchange Holidays" />

  <Block>
    {#if errorMessage}
      <Card class="bg-color-red text-color-white margin-bottom">
        <CardContent>
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <div>
              <strong>⚠️ Market Calendar API Error</strong>
              <div style="font-size: 13px; margin-top: 4px;">{errorMessage}</div>
            </div>
            <Button fill small color="white" text-color="red" onClick={loadCalendarData}>
              Retry
            </Button>
          </div>
        </CardContent>
      </Card>
    {/if}

    <Card>
      <CardHeader>Exchange Session Timings (IST)</CardHeader>
      <CardContent padding={false}>
        {#if timings.length === 0}
          <div style="padding: 16px; color: #94a3b8; text-align: center;">
            {isLoading ? "Loading session timings..." : "No session timings available"}
          </div>
        {:else}
          <List mediaList>
            {#each timings as t}
              <ListItem title={t.session} subtitle={t.time} text={t.purpose} />
            {/each}
          </List>
        {/if}
      </CardContent>
    </Card>

    <Card class="data-table">
      <CardHeader>Exchange Holidays 2026</CardHeader>
      <CardContent padding={false}>
        <table>
          <thead>
            <tr>
              <th class="label-cell">Holiday Name</th>
              <th class="label-cell">Date</th>
              <th class="label-cell">Description</th>
            </tr>
          </thead>
          <tbody>
            {#if holidays.length === 0}
              <tr>
                <td colspan="3" style="text-align: center; padding: 24px; color: #94a3b8;">
                  {isLoading ? "Loading holiday schedule..." : "No holidays recorded"}
                </td>
              </tr>
            {:else}
              {#each holidays as h}
                <tr>
                  <td class="label-cell font-bold">{h.name}</td>
                  <td class="label-cell">{h.date}</td>
                  <td class="label-cell">{h.desc}</td>
                </tr>
              {/each}
            {/if}
          </tbody>
        </table>
      </CardContent>
    </Card>
  </Block>
</Page>
